import { Button, Form, Input, Modal, Select, Spin } from 'antd';
import axios from 'axios';
import React, { Component } from 'react';
import { Constant } from '../../config';
import MyModal from '../Modal';

const { TextArea } = Input;
const { Option } = Select;

class ResubmitKYCModal extends Component {
  state = {
    loading: false,
  };

  componentDidUpdate = (preProps) => {
    if (this.props.visible === true && preProps.visible === false) {
      this.props.form.setFieldsValue({
        kyc_admin_reason_id: undefined,
        admin_note: '',
      });
      this.setState({ loadding: false });
    }
  };

  handleSubmit = (e, kycID = 0) => {
    e.preventDefault();

    if (kycID < 1 || isNaN(kycID)) {
      MyModal.error('Something went wrong. Data cannot be saved.', 'kycID=0');
      return;
    }

    this.props.form.validateFields(async (err, values) => {
      if (err) return;

      this.setState({ loading: true });

      const opt = {
        url: Constant.KYC_API_RESUBMIT.replace('[id]', kycID),
        method: 'PUT',
        data: values,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
          'Content-Type': 'application/json',
        },
      };

      try {
        await axios(opt);
      } catch (e) {
        console.log(e);
        this.setState({ loading: false });
        MyModal.error(
          'Something went wrong. Data cannot be saved.',
          JSON.stringify(e.response ? e.response.data || '' : ''),
        );
        return;
      }

      this.setState({ loading: false });
      this.props.handleModal(false);
      MyModal.success('Successfully submitted', '', () => window.location.reload());
    });
  };

  render() {
    const { loading } = this.state;
    const { form, handleModal, kycAdminReasonList, kycID, visible } = this.props;
    const { getFieldDecorator } = form;
    const footer = [
      <Button
        key="ok"
        type="primary"
        onClick={(e) => this.handleSubmit(e, kycID)}
        disabled={this.state.loading}
      >
        Submit
      </Button>,
      <Button
        key="cancel"
        onClick={() => handleModal(false)}
        disabled={this.state.loading}
      >
        Cancel
      </Button>,
    ];

    return (
      <Modal
        visible={visible}
        title={`Notify customer to do a new KYC. - KYCLOGS${kycID}`}
        maskClosable={false}
        style={{ top: 20 }}
        footer={footer}
      >
        <Spin title="Loading..." spinning={loading}>
          <Form labelCol={{ span: 5 }} wrapperCol={{ span: 16 }}>
            <Form.Item label="Reason">
              {getFieldDecorator('kyc_admin_reason_id', {
                rules: [
                  { required: true, message: 'Reason is required' },
                ],
              })(
                <Select placeholder="กรุณาเลือก">
                  {(kycAdminReasonList || []).map((v, i) => {
                    return (
                      <Option key={i} value={v.id}>
                        {v.reason}
                      </Option>
                    );
                  })}
                </Select>,
              )}
            </Form.Item>
            <Form.Item label="Remark">
              {getFieldDecorator('admin_note', {
                rules: [{ required: true, message: 'Remark is required' }],
              })(<TextArea rows={6} style={{ width: '100%' }} />)}
            </Form.Item>
          </Form>
        </Spin>
      </Modal>
    );
  }
}

export default Form.create({ name: 'resubmitKYCModal ' })(ResubmitKYCModal);



// WEBPACK FOOTER //
// ./src/containers/Payment/resubmit-kyc.modal.js